/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination';

export class CrossResourceQueryRequest {
  /**
  * List of resources and snapshots to query from. Each resource is identified by an alias that can be used in the SQL query. All resources must be stored in the same vault. 
  */
  'resources': Array<CrossResourceQueryRequestResourcesInner>;
  /**
  * SQL query using alias.schema.table references to identify tables from different resources. Support is limited to Athena [`SELECT` queries](https://docs.aws.amazon.com/athena/latest/ug/select.html). 
  */
  'query': string;
  /**
  * Eon-assigned ID of the [restore account](./list-restore-accounts).
  */
  'restoreAccountId': string;
  'destination': QueryDBRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resources",
      "baseName": "resources",
      "type": "Array<CrossResourceQueryRequestResourcesInner>",
      "format": ""
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "QueryDBRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CrossResourceQueryRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

